import { useContext } from 'react';
import WhitepagesContext from '../_contexts/WhitepagesContext';

export default function useWhitepages() {
  const { whitepages } = useContext(WhitepagesContext);

  return { whitepages };
}
